/* PrintPro welcome pop-up - two-step email capture. Built 2026-09-27.
 * Step 1 submits the email IMMEDIATELY and on its own. HubSpot native
 * multi-step forms only write on final submit, which would lose every
 * step-2 abandoner - hence two separate submissions, not one multi-step form.
 * No business-email gate: 59% of PrintPro's paying customers use a free
 * domain, including real electrical contractors. Domain type is recorded as
 * a tag instead so business domains stay routable.
 * Bot defence (v2, 2026-10-13): the visible forms carry data-hs-do-not-collect, so
 * HubSpot's collected-forms listener no longer records every submit event on its own -
 * that is how ~90 bot signups (0 page views, direct traffic) bypassed the honeypot.
 * A signup is recorded only after it passes the gates in botReason(); then a
 * throwaway form is injected and submitted for HubSpot to collect. Rejected
 * submits see the normal success screen and are simply not recorded.
 */
(function () {
  'use strict';
  var CFG = window.PPAZ_WELCOME || {};
  var PORTAL_ID = CFG.portalId || '243598806';
  var FORM_STEP1 = CFG.formStep1 || '';
  var FORM_STEP2 = CFG.formStep2 || '';
  var CODE = CFG.code || 'WELCOME15';
  var DELAY_MS = (CFG.delaySeconds || 25) * 1000;
  var SCROLL_PCT = CFG.scrollPercent || 50;
  var SUPPRESS_DAYS = CFG.suppressDays || 30;
  var DEBUG = /[?&]ppazdebug=1/.test(location.search);
  var LS_DONE = 'ppaz_welcome_done', LS_SEEN = 'ppaz_welcome_seen';
  var FREE = ['gmail.com','yahoo.com','hotmail.com','outlook.com','aol.com','icloud.com','me.com',
    'comcast.net','att.net','sbcglobal.net','verizon.net','charter.net','cox.net','msn.com',
    'live.com','ymail.com','protonmail.com','proton.me','mail.com','gmx.com'];
  var SMS = ['vtext.com','vzwpix.com','txt.att.net','mms.att.net','tmomail.net','messaging.sprintpcs.com',
    'pm.sprint.com','mymetropcs.com','sms.myboostmobile.com','msg.fi.google.com','email.uscc.net','text.republicwireless.com'];
  var MIN_OPEN_MS = 3000;
  var root, shown = false, openedAt = 0, email = '', human = false, recorded = false;

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v); }
  function domainType(v) { var d = (v.split('@')[1] || '').toLowerCase(); return FREE.indexOf(d) === -1 ? 'business' : 'free'; }

  // Subscription-bombing bots fill every email field on the web with a victim's
  // address: dotted Gmail variants (Gmail ignores dots) and SMS gateways.
  function junkEmail(v) {
    var parts = v.toLowerCase().split('@'), local = parts[0] || '', d = parts[1] || '';
    if ((d === 'gmail.com' || d === 'googlemail.com') && (local.match(/\./g) || []).length >= 3) return true;
    return SMS.indexOf(d) !== -1;
  }

  function botReason(e, val) {
    if (!shown || !openedAt) return 'not-open';
    if (e && e.isTrusted === false) return 'untrusted';
    if (!human) return 'no-input';
    if (root.querySelector('#ppazWelcomeHp').value !== '') return 'honeypot';
    if (Date.now() - openedAt < MIN_OPEN_MS) return 'too-fast';
    if (junkEmail(val)) return 'junk-email';
    return '';
  }

  // HubSpot collected forms binds to forms as they are added to the DOM, so the
  // capture form only exists once a signup has passed botReason().
  function hsCollect(fields, id) {
    try {
      var f = document.createElement('form');
      f.id = id; f.style.display = 'none'; f.setAttribute('aria-hidden', 'true');
      Object.keys(fields).forEach(function (k) {
        var i = document.createElement('input');
        i.type = k === 'email' ? 'email' : 'text'; i.name = k; i.value = fields[k];
        f.appendChild(i);
      });
      f.addEventListener('submit', function (ev) { ev.preventDefault(); });
      document.body.appendChild(f);
      setTimeout(function () {
        if (f.requestSubmit) f.requestSubmit();
        else f.dispatchEvent(new Event('submit', { cancelable: true }));
        setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 3000);
      }, 600);
    } catch (x) {}
  }

  function suppressed() {
    if (DEBUG) return false;
    if (ls(LS_DONE)) return true;
    var seen = parseInt(ls(LS_SEEN) || '0', 10);
    if (seen && (Date.now() - seen) < SUPPRESS_DAYS * 864e5) return true;
    if (/\/(cart|checkouts?|account|challenge|tools)(\/|$)/.test(location.pathname)) return true;
    if (/[?&]nopopup=/.test(location.search)) return true;
    if (window.Shopify && window.Shopify.designMode) return true;
    return false;
  }

  function hsIdentify(fields) {
    try { var q = (window._hsq = window._hsq || []); q.push(['identify', fields]); q.push(['trackPageView']); } catch (e) {}
  }

  function hsSubmit(guid, fields) {
    if (!guid) return Promise.resolve({ skipped: true });
    var ctx = { pageUri: location.href, pageName: document.title };
    try { var m = document.cookie.match(/hubspotutk=([^;]+)/); if (m) ctx.hutk = m[1]; } catch (e) {}
    return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + guid, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields: Object.keys(fields).map(function (k) { return { name: k, value: fields[k] }; }), context: ctx })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function shopifySubscribe(addr) {
    var b = new URLSearchParams();
    b.append('form_type', 'customer'); b.append('utf8', '✓');
    b.append('contact[tags]', 'newsletter,welcome-popup,domain-' + domainType(addr));
    b.append('contact[email]', addr);
    return fetch('/contact', { method: 'POST', body: b, headers: { 'Accept': 'text/html' } })['catch'](function () {});
  }

  function open() {
    if (shown || suppressed()) return;
    shown = true; openedAt = Date.now();
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    ls(LS_SEEN, String(Date.now()));
    var f = root.querySelector('#ppazWelcomeEmail');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function close() { root.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  function step(n) {
    Array.prototype.forEach.call(root.querySelectorAll('.ppaz-welcome__step'), function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-step') === String(n));
    });
  }
  function err(el, msg) { if (!el) return; el.textContent = msg || ''; el.classList.toggle('is-shown', !!msg); }

  function wire() {
    root = document.getElementById('ppazWelcome');
    if (!root) return;
    root.querySelector('.ppaz-welcome__overlay').addEventListener('click', close);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ppaz-close]'), function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    var emailEl = root.querySelector('#ppazWelcomeEmail');
    ['keydown', 'input', 'paste', 'change'].forEach(function (t) {
      emailEl.addEventListener(t, function (ev) { if (ev.isTrusted) human = true; });
    });

    var f1 = root.querySelector('#ppazWelcomeStep1');
    f1.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = root.querySelector('#ppazWelcomeEmail');
      var e1 = root.querySelector('#ppazWelcomeErr1');
      var val = (input.value || '').trim();
      if (!validEmail(val)) { input.setAttribute('aria-invalid', 'true'); return err(e1, 'Please enter a valid email address.'); }
      input.removeAttribute('aria-invalid'); err(e1, '');
      email = val;
      var why = botReason(e, val);
      if (why === 'not-open') return;
      if (why) {
        if (DEBUG) console.log('[ppaz-welcome] not recorded:', why);
        root.querySelector('#ppazWelcomeCodeVal').textContent = CODE;
        return step(2);
      }
      recorded = true;
      var btn = f1.querySelector('.ppaz-welcome__btn');
      btn.disabled = true; btn.textContent = 'Getting your code...';
      // welcome_popup_signup_date drives the Google Ads "Welcome Pop-up Signup (Offline)"
      // conversion via ~/gads/hubspot_offline_sync.py (HubSpot holds the GCLID).
      hsIdentify({ email: val, welcome_popup_signup_date: Date.now() });
      hsCollect({ email: val }, 'ppazWelcomeSignup');
      shopifySubscribe(val);
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish)
        Shopify.analytics.publish('ppaz_welcome_signup', { email_domain: domainType(val) }); } catch (x) {}
      hsSubmit(FORM_STEP1, { email: val })['catch'](function () {}).then(function () {
        ls(LS_DONE, '1');
        root.querySelector('#ppazWelcomeCodeVal').textContent = CODE;
        step(2); btn.disabled = false; btn.textContent = 'Get my code';
      });
    });

    var f2 = root.querySelector('#ppazWelcomeStep2');
    f2.addEventListener('submit', function (e) {
      e.preventDefault();
      var company = (root.querySelector('#ppazWelcomeCompany').value || '').trim();
      var phone = (root.querySelector('#ppazWelcomePhone').value || '').trim();
      var e2 = root.querySelector('#ppazWelcomeErr2');
      if (!company) return err(e2, 'Please add your company name.');
      err(e2, '');
      if (!recorded || e.isTrusted === false) return step(3);
      var btn = f2.querySelector('.ppaz-welcome__btn');
      btn.disabled = true; btn.textContent = 'Saving...';
      hsIdentify({ email: email, company: company, phone: phone });
      var fields = { email: email, company: company };
      if (phone) fields.phone = phone;
      hsCollect(fields, 'ppazWelcomeDetails');
      hsSubmit(FORM_STEP2, fields)['catch'](function () {}).then(function () { step(3); });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ppaz-copy]'), function (b) {
      b.addEventListener('click', function () {
        var v = root.querySelector('#ppazWelcomeCodeVal').textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(v);
        b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1800);
      });
    });

    if (suppressed()) return;
    setTimeout(open, DELAY_MS);
    var scrollFired = false;
    window.addEventListener('scroll', function () {
      if (scrollFired) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) * 100 >= SCROLL_PCT) { scrollFired = true; open(); }
    }, { passive: true });
    if (window.matchMedia('(min-width: 900px)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();
